import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'angular-tawk',
    template: ``,
    styles: []
})
export class AngularTawkComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @Input() isVisibleOnMobile: string;
    isMobile = false;
    script = this.renderer.createElement('script');

    constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document) { }

    ngOnInit() {
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ) {
            this.isMobile = true;
        }

        if (window[`$_Tawk`] && window[`$_Tawk`].downloaded) {
            if (this.isMobile && this.isVisibleOnMobile === 'no') {
                window[`$_Tawk`].hideWidget();
            } else {
                window[`$_Tawk`].showWidget();
            }
        } else {
            this.script.text = `var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date(), isVisible = '${this.isVisibleOnMobile}';
                (function () {
                var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
                s1.async = true;
                s1.src = 'https://embed.tawk.to/${this.id}/default';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);
                })();
                    Tawk_API.onLoad = function() {
                        if (${this.isMobile} && isVisible === 'no') {
                            Tawk_API.hideWidget();
                        }
                    };
                `;
            this.renderer.appendChild(this.document.body, this.script);
        }
    }

    ngOnDestroy() {
        if (window[`$_Tawk`] && window[`$_Tawk`].ready) {
            window[`$_Tawk`].hideWidget();
        }
    }
}
